import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function DeleteTicketsModal({ show, handleClose, onConfirm }) {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <h5>Delete Ticket</h5>
        <p>This action cannot be undone</p>

        <div className="d-flex justify-content-center gap-2">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}